import { Button } from '@/components/ui/button';
import { OnDemandUsageCard } from './OnDemandUsageCard';

export const PlanCards = () => {
    return (
        <div className="flex flex-col gap-6 mb-10">
            {/* Card 1: Current Plan (Pro+) */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm relative overflow-hidden flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                <div className="relative z-10 flex-1">
                    <div className="flex items-center gap-3 mb-2">
                        <h3 className="text-xl font-bold text-gray-900">Pro</h3>
                        <span className="px-2 py-0.5 rounded-md bg-gray-100 text-gray-600 text-xs font-bold border border-gray-200">
                            Actual
                        </span>
                    </div>
                    <div className="text-2xl font-bold text-gray-900 mb-2">USD 49 <span className="text-base font-normal text-gray-500">/mes</span></div>
                    <p className="text-gray-500 text-sm max-w-md">
                        Hasta 50.000 mensajes mensuales incluidos · Segmentación con IA ilimitada · 3 cuentas WhatsApp · Soporte prioritario.
                    </p>
                    <div className="mt-4">
                        <Button
                            variant="outline"
                            onClick={() => { window.location.href = "mailto:soporte@deenex.io?subject=Gestionar%20suscripcion"; }}
                            className="border-gray-200 text-gray-700 hover:bg-gray-50"
                        >
                            Gestionar suscripción
                        </Button>
                    </div>
                </div>

                {/* Right side: Usage Card */}
                <OnDemandUsageCard />
            </div>

            {/* Card 2: Upgrade Plan (Ultra) */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm relative overflow-hidden flex flex-col md:flex-row justify-between items-start md:items-center gap-6 opacity-90 hover:opacity-100 transition-opacity">
                <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                        <h3 className="text-xl font-bold text-gray-900">Ultra</h3>
                        <span className="text-violet-600 font-semibold text-lg">USD 200<span className="text-base font-normal text-gray-500">/mes</span></span>
                    </div>
                    <p className="text-gray-500 text-sm max-w-xl">
                        Envíos ilimitados · Cuentas WhatsApp ilimitadas · Acceso anticipado a funciones nuevas · SLA de soporte 1h.
                    </p>
                </div>
                <div>
                    <Button
                        variant="outline"
                        onClick={() => { window.location.href = "mailto:soporte@deenex.io?subject=Upgrade%20a%20Ultra"; }}
                        className="border-violet-200 text-violet-700 hover:bg-violet-50 hover:border-violet-300"
                    >
                        Pasar a Ultra
                    </Button>
                </div>
            </div>
        </div>
    );
};
